<template>
  <div id="sectionsItems" class="section-items">
      <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left :to="{ path: `/admin/projects/${$route.query.projectId}`, query: { humanId: humanId }}" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>            
        </v-flex>
      </v-layout>
    </v-container>
    <v-container v-if="!sectionObj.section" class="text-center">
        <img src="static/NoPictures.jpg" class="noItemsTemplate">
        <h4 class="pf-text-green"><b>No Item(s) Found !! </b></h4>
    </v-container>
    <v-container id="existing" xs12 v-if="sectionObj.section">
      <v-card class="ml-4 mr-4">
        <v-layout >
          <v-tabs class="xs12" style="width:100%">
            <v-tabs-slider color="#019d8c"></v-tabs-slider>
            <v-tab v-for="type of listType" :key="type" class="justify-space-around" @click="getItems(type)">
              {{type}}
            </v-tab>
            <v-tab-item
            v-for="i in listType.length"
            :key="i">
            <v-container grid-list-md fluid v-if="list.length > 0">
              <v-layout row wrap class="pt-1 pr-1 xs12 text-xs-center">
                <v-flex v-for="(item, i) in list" :key="i" xs12 sm6 md4 pa-2>
                  <v-card v-if="item.type === 'Photo'">
                    <div 
                      class="image_class"
                      :style="`background-image: url('${getPath(item.file_name, 'photos')}');`"
                    ></div>
                  <v-divider horizontal class="pf-divider"></v-divider>
                  <!-- <v-flex flat class="text-xs-center" pa-2>
                    <span>{{item.photo.caption}}</span>
                  </v-flex> -->
                </v-card>
                <v-card v-else>
              <vue-plyr :options="options">
                <div class="plyr__video-embed">
                  <iframe
                    :src="getPath(item.file_name, 'videos')"
                    allowfullscreen allowtransparency allow="autoplay">
                  </iframe>
                </div>
              </vue-plyr>
              <v-flex class="pl-1 pr-1 mb-0 text-xs-center">
                <h5 id="videoName" class="pa-2 title-display">
                  <!-- <div>
                    <span v-if="item.video.name">{{ item.video.name }}</span>
                    <span v-else>Untitled</span>
                  </div> -->
                </h5>
              </v-flex>
            </v-card>
                </v-flex>
              </v-layout>
            </v-container>
            </v-tab-item>
          </v-tabs>
        </v-layout>
      </v-card>
    </v-container>
    <!-- top tab menus end -->
  </div>
</template>
<script>
/* global session store config */

import swal from 'sweetalert2';
import { getOne, getCollection } from '../../helpers/helpers';
import { mapGetters } from 'vuex';
import $ from 'jquery';
import Vue from 'vue';

import VuePlyr from 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css';
Vue.use(VuePlyr);

export default {
  components: {

  },
  data: () => ({
    entity: 'Project',
    projectId: '',
    sectionId: '',
    projectObj: {},
    sectionObj: {},
    listType: ['Photos', 'Videos'],
    photosList: [],
    videosList: [],
    humanId: null,
    list: [],
    options: {
      controls: ['play', 'progress', 'current-time', 'mute', 'fullscreen'],
    },
    config: config
  }),
  computed: {
    ...mapGetters(['Project']),
  },
  async created () {
    this.projectId = this.$route.query.projectId;
    this.humanId = this.$route.query.humanId;
    this.sectionId = this.$route.params.id;
    await this.getProjectObj();
    if (this.projectObj.section) {
      this.sectionObj = await this.projectObj.section.find((section) => section.section.id === this.sectionId);
      this.photosList = await this.sectionObj.section.items.filter((item) => item.type === 'Photo');
      this.videosList = await this.sectionObj.section.items.filter((item) => item.type === 'Video');
      this.list = this.photosList;
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  methods: {
    getPath (name, type) {
      let path = this.config.s3BucketPath + this.config.s3Domain + '/' + this.humanId + '/VideoProject/' + this.projectId + '/' + this.sectionId + '/' + type + '/original/' + name;
      return path;
    },
    getItems (type) {
      if (type === 'Videos') {
        this.list = this.videosList;
      } else {
        this.list = this.photosList;
      }
    },
    async getProjectObj () {
      if (this.Project.length) {
        this.projectObj = this.Project.find((project) => project.id === this.projectId);
      } else {
        this.$router.push({ name: 'VideoProject' });
      }
    }
  }
};
</script>
<style scoped>
.image_class {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 240px;
}
</style>



// WEBPACK FOOTER //
// src/pages/VideoProject/adminItem.vue